module.exports = __webpack_public_path__ + "img/SW-Logo.49467576.png";